import React from "react";
import { Group, Checkbox, Text, Stack } from "@mantine/core";

export interface BarVisibilityOption {
    key: string;
    label: string;
    color: string;
}

export const DEFAULT_BAR_VISIBILITY_OPTIONS: BarVisibilityOption[] = [
    { key: "unique_users", label: "Unique Users", color: "pink" },
    { key: "messages", label: "Messages", color: "green" }
];

interface BarVisibilityToggleGroupProps {
    selectedBars: string[];
    onChange: (selectedBars: string[]) => void;
    options?: BarVisibilityOption[];
    disabled?: boolean;
    label?: string;
    orientation?: "horizontal" | "vertical";
}

export const BarVisibilityToggleGroup: React.FC<BarVisibilityToggleGroupProps> = ({
    selectedBars,
    onChange,
    options = DEFAULT_BAR_VISIBILITY_OPTIONS,
    disabled,
    label = "Show data:",
    orientation = "horizontal"
}) => {
    const handleToggle = (barKey: string) => {
        if (selectedBars.includes(barKey)) {
            // Remove the bar if it's already selected
            onChange(selectedBars.filter(key => key !== barKey));
        } else {
            // Add the bar if it's not selected
            onChange([...selectedBars, barKey]);
        }
    };

    const checkboxes = options.map(option => (
        <Checkbox
            key={option.key}
            checked={selectedBars.includes(option.key)}
            onChange={() => handleToggle(option.key)}
            disabled={disabled}
            label={option.label}
            color={option.color}
            size="sm"
        />
    ));

    const content = (
        <>
            {label && (
                <Text size="sm" fw={500} c="dimmed" style={{ whiteSpace: "nowrap" }}>
                    {label}
                </Text>
            )}
            {orientation === "horizontal" ? <Group gap="md">{checkboxes}</Group> : <Stack gap="xs">{checkboxes}</Stack>}
        </>
    );

    return orientation === "horizontal" ? (
        <Group gap="xs" align="center" style={{ flexWrap: "nowrap" }}>
            {content}
        </Group>
    ) : (
        <Stack gap="xs">{content}</Stack>
    );
};
